import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Jen aperas el nebulo, <br/>
        El nebulo blanka jen aperas mastoj, <br/>
        Kaj denove en kafejoj <br/>
        La muziko flustras pri la fora land’. <br/>
        Mian revon vokas vento, <br/>
        Vento de vojaĝoj longaj kaj miraklaj, <br/>
        Al mistera tera rand’, <br/>
        Al mistera tera rand’, <br/>
        Mi navigus al la tera rand’.
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Eble ion mi forgesis <br/>
        En pasinto, en pasinto, <br/>
        Sed ĉi tiuj rememoroj <br/>
        Gravuriĝis en anim’: <br/>
        Kaj navigas al mi ŝipoj <br/>
        El la tempo malproksima, <br/>
        Sveltaj ŝipoj blankaj kvazaŭ neĝ’ <br/>
        Sur blua mar’ sen lim’.
      </p>

      <p class="poem-block mb-3">
        Ruĝa floro en la lipoj <br/>
        Kaj rigardo flama de l’ okuloj nigraj… <br/>
        Rememoroj vekiĝintaj <br/>
        Ebriigas min pli forte ol la brand’. <br/>
        Sed denove mi foriras, <br/>
        Logas min la oceanaj vojoj migraj. <br/>
        Al mistera tera rand’, <br/>
        Al mistera tera rand’, <br/>
        Mi navigus al la tera rand’.
      </p>

      <p class="poem-block refreno mb-4">
        <span class="italic bold">Rf.</span>
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Ŝipoj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['O0rF8iwDeG4'],
    itemTranslator: `
      Komponisto kaj aŭtoro: la vortoj nekonata <br/>
      ${translator.esp}
    `
  }
}

export default item;